module.exports = __webpack_public_path__ + "img/ct_crchn.abbb3e07.png";